import React, { useState, useRef, useEffect } from 'react';
import StarDivider from './StarDivider';

interface SearchProps {
  query: string;
  onQueryChange: (query: string) => void;
  onClear: () => void;
  onEnterPress?: () => void;
  placeholder?: string;
}

const Search = ({
  query,
  onQueryChange,
  onClear,
  onEnterPress,
  placeholder = 'Search...',
}: SearchProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Auto-focus on mount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onQueryChange(e.target.value);
  };

  const handleClear = () => {
    onClear();
    inputRef.current?.focus();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      handleClear();
    } else if (e.key === 'Enter' && query.trim() && onEnterPress) {
      onEnterPress();
    }
  };

  return (
    <div className="search-container">
      <StarDivider />
      <div className={`search-input-wrapper ${isFocused ? 'focused' : ''}`}>
        <input
          ref={inputRef}
          type="text"
          value={query}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder}
          className="search-input"
          id={'search-input'}
        />

        {query && (
          <button
            onClick={handleClear}
            className="search-clear-button"
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>

      {!query && (
        <div className="search-hint">
          Try searching for "California", "CA", or "San Francisco County"
        </div>
      )}

      <StarDivider />
    </div>
  );
};

export default Search;
